export const hasQuickSearchTerm = (quickSearchTermOrObj) => {
  if (quickSearchTermOrObj && typeof quickSearchTermOrObj === 'object') {
    return !!quickSearchTermOrObj.searchTerm && quickSearchTermOrObj.searchTerm.length > 0;
  }
  return !!quickSearchTermOrObj && quickSearchTermOrObj.length > 0;
};
